import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DeliveryAuthGuard } from './guards/delivery-auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/auth/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'home',
    canActivate: [DeliveryAuthGuard],
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'order-details/:id',
    canActivate: [DeliveryAuthGuard],
    loadChildren: () =>
      import('./pages/order-details/order-details.module').then(
        (m) => m.OrderDetailsPageModule
      ),
  },
  {
    path: 'dashboard',
    canActivate: [DeliveryAuthGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule
      ),
  },
  {
    path: 'particular-order-details',
    canActivate: [DeliveryAuthGuard],
    loadChildren: () =>
      import(
        './pages/particular-order-details/particular-order-details.module'
      ).then((m) => m.ParticularOrderDetailsPageModule),
  },
  {
    path: 'fixed-point',
    canActivate: [DeliveryAuthGuard],
    loadChildren: () => import('./pages/fixed-point/fixed-point.module').then(m => m.FixedPointModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
